<template>
  <v-row>
    <v-col cols="8" style="margin-left: 16.3333333333%; padding: 0px">
      <v-container>
        <v-row>
          <v-col cols="12" class="pb-4">
            <span style="font-size: 20px;"><b>TRACER#: {{main_document[0] ? main_document[0].transaction_id : ""}}</b></span>
          </v-col>
          <v-col cols="12" class="pb-0">
            <span style="font-size: 18px"><b>Route Details</b></span>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="pb-0">
            <span><b>Subject:</b> {{subject}}</span>
          </v-col>
          <v-col cols="12" class="pb-0">
            <span><b>Urgency:</b> {{urgency}}</span>
          </v-col>
          <v-col cols="12" class="pb-0 pt-0">
            <span><b>Due Date:</b> {{moment(datetime).format("dddd, MMMM DD YYYY")}}</span>
          </v-col>
          <v-col cols="12" class="pb-0">
            <span style="font-size: 18px"><b>Receivers</b></span>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="pb-0">
            <v-simple-table dense fixed-header v-if="addedReceivers.length > 0" style="border: 1px solid rgba(0, 0, 0, 0.12); ">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">User</th>
                    <th class="text-left">Office</th>
                    <th class="text-left">
                      Action
                    </th>
                    <th>Instructions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="receiver in addedReceivers"
                    :key="receiver.index"
                  >
                    <td>
                      {{
                        `${receiver.user.first_name} ${receiver.user.middle_name} ${receiver.user.last_name}`
                      }}
                      <!-- {{
                                    receiver.user.name
                                        ? receiver.user.name
                                        : `${receiver.user.first_name} ${receiver.user.last_name}`
                                    }} -->
                    </td>
                    <td>{{ getAssignedOffice(receiver) }}</td>
                    <!-- <td v-html="receiver.instructions"></td> -->
                    <td>
                      <span v-if="receiver.action">
                        {{ receiver.action.name }}
                        {{
                          receiver.hasActionDueDate
                            ? " - " + formatDate(receiver.datetime_due)
                            : ""
                        }}
                      </span>
                      <span v-else>
                        No action added
                      </span>
                    </td>
                    <td v-dompurify-html="receiver.instructions ? getStringfromHtml(receiver.instructions) : `No instructions included` ">
                      <!-- {{
                        receiver.instructions
                          ? getStringfromHtml(receiver.instructions)
                          : "No instructions included"
                      }} -->
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="pb-0">
            <span style="font-size: 18px"><b>Documents</b></span>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="pb-0 pt-3">
            <span><b>Main:</b></span>
            <div 
              style="display: inline" v-for="item in main_document" :key="item.index">
              <a :href="`${fileSystemUrl}/view/${item.filepath_url}`" target="_blank">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge
                      class="mt-n16"
                      dot
                      color="white"
                      overlap
                    >
                      <v-icon
                      
                        v-bind="attrs"
                        v-on="on"
                        large
                        class="mx-1"
                        color="indigo"
                      >
                        mdi-file-document-outline
                      </v-icon>
                    </v-badge>
                  </template>

                  <span>
                    <v-row style="width: 500px">
                      <v-col cols="12">
                        <v-simple-table dense>
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td colspan="2">
                                  <span
                                  class="
                                    indigo--text
                                    font-weight-bold
                                  "
                                  >File name:</span>
                                  {{item.filepath_url}}
                                </td>
                                <!-- <td colspan="2">
                                  <span
                                  class="
                                    indigo--text
                                    font-weight-bold
                                  "
                                  >Type:</span>
                                  {{item.document_type ? item.document_type.name : "none"}}
                                </td> -->
                              </tr>
                              <tr>
                                <!-- <td colspan="2">
                                    <span
                                  class="
                                    indigo--text
                                    font-weight-bold
                                  "
                                  >Subject:</span>
                                  {{item.subject}}
                                </td> -->
                                <td colspan="2">
                                    <span
                                  class="
                                    indigo--text
                                    font-weight-bold
                                  "
                                  >Date Uploaded:</span>
                                  {{formatDocumentDate(item.date_uploaded)}}
                                </td>
                              </tr>
                              <!-- <tr>
                                <td colspan="2">
                                  <span
                                    class="
                                      indigo--text
                                      font-weight-bold
                                    "
                                    >File URL:</span
                                  >
                                  {{ item.filepath_url }}
                                </td>
                              </tr> -->
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </span>
                </v-tooltip>
              </a>
            </div>
          </v-col>
          <v-col cols="12" class="pt-2 pb-0">
            <span><b>Supporting:</b></span>
            <div 
              style="display: inline" v-for="(item, index) in supporting_documents" :key="index">
              <a :href="`${fileSystemUrl}/view/${item.filepath_url}`" target="_blank">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge
                      class="mt-n16"
                      dot
                      color="white"
                      overlap
                    >
                      <v-icon
                      
                        v-bind="attrs"
                        v-on="on"
                        large
                        class="mx-1"
                        color="indigo"
                      >
                        mdi-file-document-outline
                      </v-icon>
                    </v-badge>
                  </template>

                  <span>
                    <v-row style="width: 500px">
                      <v-col cols="12">
                        <v-simple-table dense>
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td colspan="2">
                                  <span
                                  class="
                                    indigo--text
                                    font-weight-bold
                                  "
                                  >File name:</span>
                                  {{item.filepath_url}}
                                </td>
                              </tr>
                              <tr>
                                <td colspan="2">
                                    <span
                                  class="
                                    indigo--text
                                    font-weight-bold
                                  "
                                  >Date uploaded:</span>
                                  {{formatDocumentDate(item.date_uploaded)}}
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </span>
                </v-tooltip>
              </a>
            </div>
          </v-col>
          <v-col cols="12" class="pb-0">
            <span><b>Routed by: </b>{{loggedInUserName}}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
import { fileSystemUrl } from '../config/config.json'
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  name: "Preview",
  props: {
    showSelect: String,
    urgency: String,
    subject: String,
    datetime: String,
    isSaving: Boolean,
  },
  data() {
    return {
        main_document: [],
        supporting_documents: [],
        fileSystemUrl: fileSystemUrl,
    };
  },
  methods: {
      ...mapActions(["switchMainDocument"]),
      formatDocumentDate(date) {
        return moment(date).format("LLL");
      },
      formatDate(date) {
        return moment(new Date(date)).format("dddd, MMMM DD YYYY");
      },
      getStringfromHtml(html){
          var txt = document.createElement("textarea");
          txt.innerHTML = html;
          return txt.value;
      },  
      getAssignedOffice(receiver){
        let office_name = ""
        this.allUsersByOffice.forEach(element => {
          if (element.user_id == receiver.user.id) {
            office_name = element.name
          }
        });
        return office_name
      },
      getMainDocument(){
          this.addedDocuments.forEach(document => {
            if(document.isMainDocument)
              this.main_document.push({filepath_url: document.filepath_url, date_uploaded: document.date_uploaded})
            else
              this.supporting_documents.push({filepath_url: document.filepath_url, date_uploaded: document.date_uploaded})
          })
          this.getSupportingDocuments.forEach(item => {
            if(item.isMainDocument)
              this.main_document.push({filepath_url: item.document.filepath_url, date_uploaded: item.document.date_uploaded})
            else
              this.supporting_documents.push({filepath_url: item.document.filepath_url, date_uploaded: item.document.date_uploaded})
          })
          // this.swapfiles()
      },
      swapfiles(){
        this.addedDocuments.forEach(document => {
          document.isMainDocument = true
          let original_main_filepath_url = null
          this.getSupportingDocuments.forEach(item => {
            if(item.isMainDocument){
              original_main_filepath_url = document.filepath_url
              document.filepath_url = item.document.filepath_url
              item.document.filepath_url = original_main_filepath_url
              let body = {
                main_document_id: item.document.id,
                old_main_document_id: document.id
              }
              this.switchMainDocument(body)
            }
          })
        })
      },
  },
  computed: {
    ...mapGetters(["addedReceivers", "allUsersByOffice", "addedDocuments", "loggedInUserName", "getSupportingDocuments"]),
  },
  watch: {
      showSelect: {
          handler() {
              if(this.showSelect == "Review"){
                this.getMainDocument()
                
              }else{
                  this.main_document = []
                  this.supporting_documents = []
              }
          }
      },
      isSaving: {
        handler(){
          if(this.isSaving)
            this.swapfiles()
        }

      }
  }
};
</script>